const initialState = {
  text: '',
  detailsDocuments: [],
};

const GET_DETAILS_DOCUMENTS = 'GET_DETAILS_DOCUMENTS';

export const detailsDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAILS_DOCUMENTS:
      return { ...state, detailsDocuments: action.payload.files, text: action.payload.text };
    default:
      return state;
  }
};

export const getDetailsDocumentsAction = (payload) => ({ type: GET_DETAILS_DOCUMENTS, payload });
